import { Table as AntdTable, TableProps } from "antd";
import { useEffect, useState } from "react";
import { Flex } from "../Layouts/Flex/Flex.styles";
import { Pagination } from "../Pagination/Pagination";
import tableStyle from "./Table.module.css";

export interface CustomTableProps {
  columns: TableProps["columns"];
  isLoading: boolean;
  fetchData: (currentPage: number, pageSize: number) => {};
  dataSource: any[];
  total: number;
  row?: (props: any) => {};
  onRow?: (record: any) => {};
  cell?: JSX.Element;
}

export const Table = ({
  columns,
  isLoading,
  fetchData,
  dataSource,
  total,
  row,
  onRow,
  cell,
}: CustomTableProps) => {
  const [body, setBody] = useState({});

  useEffect(() => {
    if (row) setBody((prev) => ({ ...prev, row }));
    if (cell) setBody((prev) => ({ ...prev, cell }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const components = {
    body: {
      cell: ({ children, ...props }: any) => (
        <td {...props} className={tableStyle.cardCell}>
          {children}
        </td>
      ),
    },
  };

  return (
    <div className={tableStyle.glassWrapper}>
      <AntdTable
        id="data-table"
        className={tableStyle.table}
        size="small"
        tableLayout="fixed"
        columns={columns?.map((col) => ({
          ...col,
          ellipsis: { showTitle: true }, 
        }))}
        dataSource={dataSource.map((data: any) => ({
          ...data,
          key: data.id,
        }))}
        loading={isLoading}
        components={{
          body,
        }}
        scroll={{ y: "calc(100dvh - 330px)" }}
        pagination={false}
        onRow={onRow}
      />
      <Flex justifyContent="flex-end" margin="10px 0 0 0">
        <Pagination total={total} onChange={(cp, ps) => fetchData(cp, ps)} />
      </Flex>
    </div>
  );
};
